// extracted by mini-css-extract-plugin
export default {"linkColor":"menuDrop_linkColor__Ps0sD"};